<template>
  <div class="px-3 px-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 rounded-2 bg-white py-4 w-100">
    <div class="d-flex flex-wrap align-items-center gap-2 w-100">
      <div class="d-flex flex-wrap align-items-center me-auto mb-2 mb-md-0">
        <div class="d-flex align-items-center flex-wrap gap-2">
          <div class="bg-white shadow justify-content-center align-items-center px-1 me-3 rounded-2">
            <a @click="changeModelViewType(modelViewType.calendar)"
              :class="route.query.viewType === modelViewType.calendar ? 'active' : ''"
              class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon me-1"
              :title="$t('appointments.calendar')"
            >
              <i class="fas fa-calendar-alt text-primary fs-4"></i>
            </a>
            <a @click="changeModelViewType(modelViewType.list)"
              :class="(route.query.viewType === modelViewType.list || !route.query.viewType) ? 'active' : ''"
              class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon"
              :title="$t('appointments.list')"
            >
              <i class="bi bi-list-task text-primary fs-4"></i>
            </a>
            
          </div>
          <div v-show="route.query.viewType !== modelViewType.calendar">
            <DateRangePicker :id="id" @update:date="handleRangeDate" />
          </div>
          <ButtonDropdownFilter
              :search="false"
              :options="statusList"
              value-field="value"
              :name-field="locale"
              v-model="query.status"
          />
          <ButtonDropdownFilter
              :options="Object.values(typeList)"
              value-field="id"
              name-field="name"
              v-model="query.type"
          />
        </div>
      </div>

      <div class="d-flex align-items-center mt-2 mt-md-0">
        <Input
            v-if="showSearch"
            container-class="me-2"
            size="sm"
            inputClass="form-control form-control-sm"
            name="input-search"
            :isInputGroup="true"
            :placeholder="$t('label.search')"
            v-model="query.search"
        >
          <template #rightAddon>
            <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
              <i class="fa fa-search"></i>
            </span>
          </template>
        </Input>

        <Button v-if="$can(abilities.CREATE_APPOINTMENT)" type="new" btn-class="btn-sm" btn-text="appointments.create" @click="openCreateView" ></Button>
      </div>
  </div>
 </div>
</template>
<script setup>
import DateRangePicker from "@/components/DateRangePicker.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import { useLocales } from "@/composables/locales";
import {computed} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute, useRouter} from "vue-router";
import {useModelViewType} from "@/composables/modelViewType";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import abilities from "@/composables/abilities";

const router = useRouter()
const route = useRoute()
const { modelViewType } = useModelViewType()

const {locale} = useLocales()

const props = defineProps({
  handleRangeDate: {type: Function, default: () => {}},
  types: { type: Object, default:  {}},
  status: { type: Object, default:  {}},
  id: {type: String, default: 'kt_td_picker_button'},
  query: {type: Object, default: {start_date: '', end_date: '', search: '', status: '', type: ''}},
  showSearch: {type: Boolean, default: true}
})

const typeList = computed(() => {
  return [{ id: 'all', name: i18n.global.t('appointments.allCanal') }, ...props.types];
});

const statusList = computed(() => {
  return [{ value: 'all', fr: i18n.global.t('appointments.allStatus'), en: i18n.global.t('appointments.allStatus') }, ...props.status];
});

function changeModelViewType (viewType) {
  router.push({ query: { viewType } });
}

function openCreateView(){
  router.push({ name: 'appointments-create' })
}

</script>
<style scoped>
  @import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css";
</style>
